export const ADD_ERROR = '@logging/ADD_ERROR';
